.checkout-container{
    width: 100%;
}

.checkout-content{
    display: flex;
    justify-content: center;
    width: 100%;
}

.checkout-split{
    display: flex;
    width: 100%;
}

.checkout-left{
    flex: 1;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 64px 24px;
    padding-right: 160px;
}

.checkout-cart-wrapper{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}

.checkout-right{
    flex: 1;
    background-color: #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 64px 24px;
    padding-left: 64px;
}

.checkout-form-column{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 12px;
    max-width: 584px;
}

.checkout-boxes{
    display: flex;
    flex-wrap: wrap;
    gap: 48px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1100px;
}

.checkout-boxes .checkout-form-column{
    flex-grow: 1;
}

.checkout-order-summary {
    flex-shrink: 0;
}

.checkout-order-summary .order-summary-box {
    position: static;
    right: auto;
    margin-top: 0;
    max-height: none;
    width: 400px;
}

.checkout-order-summary .cart-summary-standalone {
    padding-top: 12px;
}


.checkout-header{
    font-family: 'Golos Text SemiBold', 'proxima-nova', sans-serif;
    font-size: 22px;
    font-weight: 600;
    line-height: 24px;
    color: #000;
}

.login-box{
    border: 1px solid #157AFF;
    padding: 24px 32px;
}

.login-box-checkout {
    background-color: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 12px;
    padding: 24px;
    width: 100%;
}

.billing-container .form-input,
.billing-container .form-select{
    margin-bottom: 16px;
}

.billing-container{
    flex-grow: 1;
    max-width: 584px;
}

.billing-container select{
    background: url(https://checkout-redesign--borisfx.netlify.app/svgs/select-arrow.svg) no-repeat right white;
    -webkit-appearance: none;
    -moz-appearance:none;
    appearance: none;
}

.checkout-sections{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.checkout-sections .box-accent{
    border-color: #0E8CDB;
}

.checkout-section-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-bottom: 1px solid #E5E5E5;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 500;
}

.checkout-section-title-icon{
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}

.checkout-section-title-icon img{
    width: 20px;
    height: 20px;
    display: block;
}

.checkout-section-body{
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.checkout-section-body-text{
    color: rgba(0, 0, 0, 0.65);
    font-size: 16px;
    line-height: 24px;
}

.billing-header{
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
}

.checkout-step-list{
    padding: 0;
    display: flex;
    gap: 5rem;
    list-style: none;
    font-family: 'Golos Text Regular', 'proxima-nova', sans-serif;
    font-size: 14px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.65);
}

.checkout-step-list .active{
    color: #000;
    font-family: 'Golos Text SemiBold', 'proxima-nova', sans-serif;
}

.inverted-box{
    background-color: #101010;
    border: 1px solid rgba(255, 255, 255, 25%);
}

.summary-container{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.line-items{
    width: 400px;
    padding: 32px;
}

.line-items:not(:last-child){
    margin-bottom: 16px;
}

.line-items .d-flex {
    flex-direction: column;
    align-items: flex-start;
}

.line-item-image-container {
    flex-shrink: 0;
}

.line-item-image{
    width: auto;
    height: 34px;
    max-width: 100%;
    object-fit: contain;
    object-position: left;
}

.product-details{
    margin-left: 0;
    padding-top: 8px;
}

.product-details span{
    margin-bottom: 2px;
    display: block;
}

.product-title{
    font-size: 1rem;
    margin-bottom: 4px;
}

.line-item-details{
    margin-top: 16px; 
}

.line-item-field, .totals-field{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
}

.line-item-field label{
    font-weight: 600;
    margin: 0;
}

.line-item-field:last-child{
    margin-bottom: 0;
}

.line-item-discount{
    font-size: 16px;
    color: #F2545B;
    font-family: 'Golos Text Semibold';
}

.line-item-list-price{
    color: rgba(0, 0, 0, 0.87);
    text-align: left;
    font-size: 16px;
    text-decoration: line-through;
    font-family: 'Golos Text Semibold';
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.3px;
    margin-left: 8px;
}

.totals-field label{
    margin: 0;
}

.line-item-field input, .line-item-field select{
    border: 1px solid rgba(0, 0, 0, 12%);
}


.line-item-field input{
    max-width: 30%;
}

.vat-form{
    display: flex;
    gap: 8px;
}

.vat-container{
    display: flex;
    gap: 0;
}

.vat-country-code{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0 4px;
    border-right: none!important;
    border-radius: 4px 0 0 4px;
    border: 1px solid rgba(0, 0, 0, 38%);
    background-color: rgba(0, 0, 0, 12%);
}

.vat-input-container{
    display: inline-block;
}

.vat-input{
    padding-left: 0!important;
    border-left-color: rgba(0, 0, 0, 0)!important;
    border-radius: 0 4px 4px 0!important;
    max-width: 122px;
}

.vat-input:focus, .vat-input:focus-visible{
    outline: none;
    border: 2px solid rgb(0, 95, 204);
    border-left: 2px solid rgb(0, 95, 204)!important;
    border-radius: 0 4px 4px 0!important;
}


.hub-discount-container, .checkout-vat-container{
    padding: 16px 32px;
    display:flex;
    align-items: center;
}

.discount-code-form{
    display: flex;
    gap: 8px;
    margin: 0;
}

.discount-code-text{
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(0, 0, 0, .65);
}

.discount-button{
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    padding: 8px 32px;
    margin-top: 22px;
    height: 40px;
    background-color: #E5E5E6!important;
    color: rgba(0, 0, 0, 87%);
}

.discount-button:hover{
    background-color: #E5E5E6!important;
    color:rgba(0, 0, 0, 87%);
    cursor: pointer;
}

.checkout-totals{
    max-width: 400px;
    padding: 16px 32px;
}


.total-price, .total-label{
    font-weight: 600;
}

.external-login-buttons{
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
}

.spring-sale-disclaimer{
    padding: 16px 32px;
    width: 400px;
    font-size: 12px;
}

@media screen and (max-width: 1100px) {
    .checkout-left {
        padding-right: 48px;
    }
    .checkout-right {
        padding-left: 32px;
    }
}

@media screen and (max-width: 900px) {
    .checkout-split{
        flex-direction: column;
    }

    .checkout-left {
        padding-right: 24px;
        justify-content: center;
    }
    .checkout-right {
        padding-left: 24px;
        justify-content: center;
    }

    .checkout-cart-wrapper {
        justify-content: center;
    }

    .checkout-container{
        display:flex;
        flex-direction: column;
        justify-content: center;
    }
    .checkout-boxes{
        justify-content: center;
    }
    .summary-container, .summary-container .box{
        width: 100%;
        max-width:584px;
    }
}

@media screen and (max-width: 500px){
    .checkout-container{
        margin: 0 8px;
    }

    .checkout-left-panel{
        width: 100%;
    }

    .checkout-step-list{
        gap: 1rem;
    }

    .login-box{
        padding: 16px;
        width: 100%;
    }
}